import { Category, Manufacturer } from '@/services/api/contracts/catalog/types';
import { Region } from '@/services/api/contracts/region';
import { useMemo } from 'react';
import { Result } from '../bulkUploadHelper';

export const getMismatchedManufacturers = (result: Result, manufacturers: Manufacturer[]) => {
  const unique = new Set(result.data.map(p => p.Manufacturer));
  return [...unique].filter(m => !manufacturers.find(manufacturer => manufacturer.name === m));
};

export const useMismatchedManufacturers = (result: Result, manufacturers: Manufacturer[]) => {
  return useMemo(() => getMismatchedManufacturers(result, manufacturers), [result, manufacturers]);
};

export const getMismatchedCategories = (result: Result, categories: Category[]) => {
  const unique = new Set(result.data.map(p => p.Category));
  return [...unique].filter(m => !categories.find(category => category.name === m));
};

export const useMismatchedCategories = (result: Result, categories: Category[]) => {
  return useMemo(() => getMismatchedCategories(result, categories), [result, categories]);
};

export const getMismatchedRegions = (result: Result, regions: Region[]) => {
  const unique = new Set(result.data.map(p => p.Region));
  return [...unique].filter(m => !regions.find(region => region.code === m));
};

export const useMismatchedRegions = (result: Result, regions: Region[]) => {
  return useMemo(() => getMismatchedRegions(result, regions), [result, regions]);
};
